<template>
  <div class="h5-upload clear">
    <div v-if="verifyImg" class="upload-desc sample-box">
      <el-image class="el-image-opacity" :src="verifyImg" :preview-src-list="[verifyImg]" />
      <el-image
        class="verify-icon"
        :src="require('@/assets/PC/img/verify-icon@2x.png')"
      ></el-image>
    </div>
    <template v-else>
      <!-- 示例图 从调用的父组件传进来 -->
      <div v-if="sampleImg" class="upload-desc sample-box">
        <el-image :src="sampleImg" :preview-src-list="[sampleImg]" />
        <div class="sample-tag">{{ $t("other.shiliTu") }}</div>
      </div>
      <div v-if="imageFile" class="delete-box">
        <el-image :src="imageFile" :preview-src-list="[imageFile]">
          <!--加载失败-->
          <div class="el-image__error" slot="error">{{$t('other.loadFail')}}</div>
        </el-image>
        <div class="delete-icon">
          <img
            @click="deleteImg"
            :src="require('@/assets/PC/icons/icon-delete@2x.png')"
            alt=""
          />
        </div>
      </div>
      <el-upload
        v-else
        id="uploadDom"
        action=""
        class="avatar-uploader"
        :show-file-list="false"
        :before-upload="afterRead"
      >
        <img v-if="imageFile" :src="imageFile" class="avatar" />
        <div class="upload-desc" v-else>
          <div>
            <img :src="require('@/assets/PC/img/plus@2x.png')" alt="" />
            <div>{{ $t("pc.upload") }}</div>
          </div>
        </div>
      </el-upload>
    </template>
  </div>
</template>

<script>
// import { vm } from "@/libs/lang";
// import { uploadImg } from "@/axios/uploadImg.js";
import { validateUploadFile, buildUploadRealName } from "@/utils/uploadPolicy.js";
export default {
  name: "h5Upload",
  props: {
    maxCount: {
      type: Number,
      default: 1,
    },
    keyValue: {
      type: String,
      default: "",
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    staticSmallImg_mutiOneCase: {
      type: String,
      default: "",
    },
    staticBigImg_mutiOneCase: {
      type: String,
      default: "",
    },
    sampleImg: {
      //示例图
      type: String,
      default: "",
    },
    verifyImg: {
      //已验证图片
      type: String,
      default: "",
    },
  },
  data() {
    return {
      images: null,
      show: false,
      fileList: [],
      imageFile: null,
    };
  },
  methods: {
    // 预览图片
    showViewImage(img) {
      console.log("预览图片", img);
      this.show = true;
      this.images = Array.isArray(img) ? img : [img];
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = this.$t("upload.uploading");
      const target = document.querySelector("#uploadDom");
      const loading = this.$loading({
        target,
        lock: true,
        customClass: "customClass",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
      });
      this.getBase64(file).then((resBase64) => {
        this.imageFile = resBase64;
      });
      const params = {
        file: file,
        key: this.keyValue,
        photoIndex: 0,
      };
      // 上传结束后的回调 YH000541
      params.uploadCallback = (res) => {
        console.log("---执行callback", res);
        if (res) {
          file.status = "done";
          file.message = "上传成功";
        } else {
          file.status = "failed";
          file.message = this.$t("upload.uploadFail");
        }
      };
      this.uploadFile(params);
      loading?.close();
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    deleteImg() {
      console.log(4332432);
      const params = {
        key: this.keyValue,
        photoIndex: 0,
        id: this.id,
      };
      this.imageFile = null;
      this.$emit("delete", params);
    },
    deleteImg_mutiOneCase(photoIndex) {
      const params = {
        key: this.keyValue,
        photoIndex,
        id: this.id,
      };
      this.fileList.splice(photoIndex, 1);
      console.log(params);
      this.$emit("delete", params);
      return true;
    },
    // 获取POST上传授权
    policyPostUpload(file, contentType) {
      return new Promise((resolve, reject) => {
        this.$api
          .policyPutUpload({
            realName: buildUploadRealName(file, contentType),
            contentType,
          })
          .then((res) => {
            if (res?.code == "0000") {
              let {
                host,
                authority,
                dir,
                policy,
                accessid,
                callback,
                signature,
              } = res.data;

              let actionUrl = host;
              let imgName = (dir && dir.split('/').pop()) || `${Date.now()}.jpg`;
              let uploadData = {};
              uploadData.name = imgName;
              uploadData["x-oss-object-acl"] = authority || "public-read";
              uploadData.key = dir;
              uploadData.policy = policy;
              uploadData.OSSAccessKeyId = accessid;
              uploadData.success_action_status = 200;
              uploadData.callback = callback;
              uploadData.signature = signature;

              // if(isVrs && _this.$isOpenInWebview){}

              //this.uploadImgApi(file, actionUrl, uploadData)
              resolve({
                actionUrl,
                uploadData,
              });
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    // 上传到服务器
    uploadImg_http(file, actionUrl, uploadData) {
      let formData = new FormData();
      formData.append("name", uploadData.name);
      formData.append("x-oss-object-acl", uploadData["x-oss-object-acl"]);
      formData.append("key", uploadData.key);
      formData.append("policy", uploadData.policy);
      formData.append("OSSAccessKeyId", uploadData.OSSAccessKeyId);
      formData.append(
        "success_action_status",
        uploadData.success_action_status
      );
      formData.append("callback", uploadData.callback);
      formData.append("signature", uploadData.signature);
      formData.append("file", file);
      return new Promise((resolve, reject) => {
        uploadImg(actionUrl, formData)
          .then((res) => {
            if (res && res.data && res.data.code === "0000") {
              let id = res?.data?.data?.id;
              let url = res?.data?.data?.url;
              let obj = {
                id,
                url,
              };
              resolve(obj);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    /**
     * 上传
     */
    async uploadFile(file) {
      file.status = "uploading";
      // file.message = vm.$t("upload.uploading"); //'上传中...'
      file.message = '上传中...'
      try {
        const rawFile = file.file || file;
        const check = validateUploadFile(rawFile, { category: 'image' });
        if (!check.valid) {
          file.status = "failed";
          file.message = check.message;
          this.$message && this.$message.warning(check.message);
          this.$emit("afterRead", {});
          return;
        }
        let data = await this.policyPostUpload(rawFile, check.contentType); // actionUrl,uploadData,
        let res = await this.uploadImg_http(
          rawFile,
          data?.actionUrl,
          data?.uploadData
        );
        file.status = "success";
        file.message = "上传成功";
        console.log("图片上传成功", res);
        // 对外抛出结果
        this.$emit("afterRead", res || {});
      } catch (error) {
        debugger
        file.status = "failed";
        // file.message = vm.$t("upload.uploadFail"); //'上传失败'
        file.message = '上传失败'
        this.$emit("afterRead", {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .staticSmallImg_mutiOneCase .van-uploader__preview {
  display: none;
}
.img-item-staticBigImg_mutiOneCase {
  margin-bottom: 9px;
  width: 150px;
  // display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.img-item-staticBigImg_mutiOneCase:nth-child(2n + 1) {
  margin-right: 20px;
}
.img-item-0 {
  margin-bottom: 0;
}
.uploader {
  width: 150px;
  height: 150px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .img-tips {
    width: 40px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .desc {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999;
    margin-top: 10px;
  }
}

.h5-upload {
  & /deep/ .van-uploader__wrapper {
    flex-wrap: wrap;
    margin-right: 0;
  }
  & /deep/ .van-uploader {
    .van-uploader__preview {
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right: 0;
      margin-bottom: 0;
    }

    .van-image {
      width: 200px;
      height: 200px;
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .van-uploader__preview:nth-child(2n + 1) {
      // margin-right: 20px;
    }
    .van-uploader__input-wrapper {
      justify-content: space-between;
      flex-wrap: wrap;
      margin-right: 0;
    }
  }
}

.uploader {
  display: flex;
  justify-content: center;
  align-items: center;
}
.h5-upload.clear {
  // background: #f2f2f2 !important;
  //width: 150px;
  // height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ div {
  .van-uploader__input-wrapper {
    width: 200px !important;
    height: 200px !important;
    display: flex;
    justify-content: center !important;
    align-items: center;
    background: #f2f2f2;
    .uploader {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0;
      img {
        margin-right: 0;
      }
    }
  }
}
/deep/ .van-uploader__preview-delete {
  width: 40px;
  height: 40px;
  border-radius: 0 0 0 40px;
}
/deep/ .van-uploader__preview-delete-icon::before {
  width: 20px;
  height: 20px;
  font-size: 20px !important;
}
/deep/ .van-uploader__preview-delete-icon {
  top: 6px;
  right: 6px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.upload-desc {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  text-align: center;
  display: flex;
  background: #f2f2f2;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px 4px 4px 4px;
  > div {
    font-size: 16px;
    color: #6e6e6e;
  }
  img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
    border-radius: 4px;
  }
}
/deep/ .el-image {
  width: 180px;
  height: 180px;
}
.delete-box {
  position: relative;
  background: #ffffff;
  opacity: 1;
  overflow: hidden;

  .delete-icon {
    position: absolute;
    top: -20px;
    right: -20px;
    background: black;
    width: 40px;
    height: 40px;
    text-align: center;
    border-radius: 50%;
    opacity: 0.5;
    img {
      cursor: pointer;
      width: 10px;
      height: 10px;
      margin-top: 23px;
      margin-right: 19px;
    }
  }
}
.sample-box {
  flex-shrink: 0;
  margin-right: 20px;
  position: relative;
  .sample-icon {
    width: 100%;
    height: 100%;
    margin: 0;
  }
  .sample-tag {
    position: absolute;
    border-radius: 4px 0px 4px 0px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 14px;
    height: 24px;
    padding: 0 8px;
    text-align: center;
    top: 0;
    left: 0;
    line-height: 24px;
  }
  .sample-content {
    width: 100%;
    height: 100%;
  }
}
/deep/.el-loading-mask {
  display: flex;
  align-items: center;
}
/deep/.el-icon-loading {
  color: white;
  font-size: 18px;
}
.verify-icon {
  width: 60px;
  height: 60px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.el-image-opacity {
  position: relative;
}
.el-image-opacity::before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  width: 180px;
  height: 180px;
  background-color: rgba(0, 0, 0, .2);
}
</style>
